module.exports = __webpack_public_path__ + "static/media/testCustomerInventoryGenerateTrackedObjectsWithTagshomepage.9d431abd.png";